import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { Link } from 'react-router-dom';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';

interface FooterLogoProps {
  className?: string;
}

const FooterLogo: React.FC<FooterLogoProps> = ({ className = "" }) => {
  const isMobile = useIsMobile();
  const { resolvedTheme } = useTheme();
  
  // Use different logo based on theme - independent from header logo
  const logoSrc = resolvedTheme === 'dark' 
    ? "/lovable-uploads/e0860118-659d-4f83-a9bf-4d16823ced7b.png" // Dark theme logo
    : "/lovable-uploads/6ba89a66-4744-4fbc-8a6c-aea02dd5dafb.png"; // Light theme logo

  return (
    <Link to="/" className={cn(className)}>
      <img 
        src={logoSrc}
        alt="Everhouse" 
        className="h-4 w-auto object-contain"
      />
    </Link>
  );
};

export default FooterLogo;